import { Component } from '@angular/core';

@Component({
  selector: 'kp-eligibility-header',
  templateUrl: './eligibility-header.component.html',
  styleUrls: ['./eligibility-header.component.scss'],
})
export class EligibilityHeaderComponent {}
